import { useState } from "react";

import styles from "./TermsPrivacySection.module.css";

import PolicyCard from "./PolicyCard";

import PolicyViewer from "./PolicyViewer";

import { POLICIES } from "./PolicyData";

import {
TERMS,
PRIVACY,
COOKIE,
DISCLAIMER
}
from "./PolicyContent";

export default function TermsPrivacySection(){

const [selected,setSelected]=useState(null);

const CONTENT={
terms:TERMS,
privacy:PRIVACY,
cookie:COOKIE,
disclaimer:DISCLAIMER
};

if(selected){

return (

<PolicyViewer
title={selected.title}
icon={selected.icon}
content={CONTENT[selected.id]}
onBack={()=>setSelected(null)}
/>

);

}

return (

<div className={styles.grid}>

{POLICIES.map(item=>(

<PolicyCard
key={item.id}
{...item}
onClick={()=>setSelected(item)}
/>

))}

</div>

);

}